import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { EditorChoiceDataSource, HubEvent } from '../../../../models/hub/hub.event';
import { HubPlace } from '../../../../models/hub/hub.place';
import { ImageService } from '../../../../services/image.service';
import { EventDetailsModalComponent } from '../../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../../event.details.modal/event.details.modal.provider';
import { PlaceDetailsModalComponent } from '../../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
import { PlaceService } from '../../../../services/place.service';

@Component({
  selector: 'ig-visitor-long-card',
  templateUrl: './visitor.long.card.component.html',
  styleUrls: ['./visitor.long.card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorLongCardComponent extends BaseComponent implements OnInit {
  @Input() public item: HubEvent | HubPlace;
  @Input() public preventClick = false;
  public eventTimeText = '';
  public placeCategory = '';
  public hubName: string;
  public editorChoiceText = '';

  constructor(
    private router: Router,
    public imageService: ImageService,
    public modalService: ModalService,
    public editorChoiceStore: EditorChoiceStore,
    private customizationApiService: CustomizationApiService,
    private activatedRoute: ActivatedRoute
  ) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    if (this.item.startTime) {
      this.eventTimeText = this.isMobile
        ? this.item.startTimeFormatted
        : `${this.item.startTimeFormatted}${this.item.endTimeFormatted ? ' - ' + this.item.endTimeFormatted : ''}`;
    } else {
      if (this.item['categoryList']) {
        this.placeCategory = '';
        let cate = '';
        for (let category of this.item['categoryList']) {
          cate += PlaceService.toReadableCategory(category) + ', ';
          if (cate.length < 44) {
            this.placeCategory = cate;
          }
        }
        // remove the last comma
        this.placeCategory = this.placeCategory.substr(0, this.placeCategory.length - 2);
      }
    }
    this.editorChoiceTextHandler();
  }

  public editorChoiceTextHandler() {
    this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe((editorChoice: EditorChoiceDataSource) => {
      if (!!this.item.startTime) {
        this.editorChoiceText = editorChoice.editorChoiceForEvent;
      } else {
        this.editorChoiceText = editorChoice.editorChoiceForPlace;
      }
    });
  }

  public enterItemByKeyboard($event) {
    if ($event && $event.key === 'Enter') {
      this.showDetails();
    }
  }

  public showDetails() {
    if (this.preventClick) {
      return;
    }
    if (this.item.isPromotionImage) {
      this.item.promotionLink = this.item.promotionLink.startsWith('http')
        ? this.item.promotionLink
        : 'http://' + this.item.promotionLink;
      window.open(this.item.promotionLink, '_blank');
      return;
    }

    let {hubName, category, menuType} = this.allRouteParams;
    if (this.item.startTime) {
      // this is an event
      if (!this.isMobile) {
        this.item.hubName = this.hubName;
        let actions = <EventDetailsModalActions>{
          confirm: (event: ButtonTriggerEvent, data: any) => {
          },
        };

        this.modalService.show({
          component: EventDetailsModalComponent,
          providers: [
            {provide: EventDetailsModalActions, useValue: actions},
            {provide: HubEvent, useValue: this.item},
          ],
          panelClass: 'modal-fixed-top-lower',
        });
      } else {
        this.showDetailModalForMobile(this.item, 'event');
        // this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventDetails,
        //     {
        //         hubName,
        //         eventId: this.item._id
        //     }), {skipLocationChange: this.noChangeUrlWhenRedirect});
      }
    } else {
      // this is a place
      if (!this.isMobile) {
        let actions = <PlaceDetailsModalActions>{
          confirm: (event: ButtonTriggerEvent, data: any) => {
          },
        };

        this.modalService.show({
          component: PlaceDetailsModalComponent,
          providers: [
            {provide: PlaceDetailsModalActions, useValue: actions},
            {provide: HubPlace, useValue: this.item},
          ],
          panelClass: 'modal-fixed-top',
        });
      } else {
        this.showDetailModalForMobile(this.item, 'place');
        // category = PlaceCategory.getPlaceCategoryKey(category);
        // this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeDetails,
        //     {
        //         hubName,
        //         placeId: this.item._id,
        //         category: category,
        //         menuType: menuType
        //     }), {skipLocationChange: this.noChangeUrlWhenRedirect});
      }
    }
  }

  public showDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = false, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
      },
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
        },
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }

  public remove() {
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/long.card/visitor.long.card.component.ts